import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import { useTranslation } from "react-i18next";

const PricingSection = () => {
  const { t } = useTranslation();

  const plans = [
    {
      name: t("landing.assessmentLibrary.pricing.free.name"),
      badge: t("landing.assessmentLibrary.pricing.free.badge"),
      price: "0",
      currency: t("landing.assessmentLibrary.pricing.currency"),
      features: [
        t("landing.assessmentLibrary.pricing.free.features.credits"),
        t("landing.assessmentLibrary.pricing.free.features.users"),
        t("landing.assessmentLibrary.pricing.free.features.trial"),
        t("landing.assessmentLibrary.pricing.free.features.ats"),
        t("landing.assessmentLibrary.pricing.free.features.testInventories"),
        t("landing.assessmentLibrary.pricing.free.features.antiCheating"),
      ],
      highlighted: false,
    },
    {
      name: t("landing.assessmentLibrary.pricing.basic.name"),
      badge: t("landing.assessmentLibrary.pricing.basic.badge"),
      price: "100",
      monthlyPrice: "100",
      annualPrice: "1200",
      currency: t("landing.assessmentLibrary.pricing.currency"),
      features: [
        t("landing.assessmentLibrary.pricing.basic.features.credits"),
        t("landing.assessmentLibrary.pricing.basic.features.users"),
        t("landing.assessmentLibrary.pricing.basic.features.ats"),
        t("landing.assessmentLibrary.pricing.basic.features.testInventories"),
        t("landing.assessmentLibrary.pricing.basic.features.library"),
        t("landing.assessmentLibrary.pricing.basic.features.antiCheating"),
        t("landing.assessmentLibrary.pricing.basic.features.support"),
      ],
      highlighted: false,
    },
    {
      name: t("landing.assessmentLibrary.pricing.business.name"),
      badge: t("landing.assessmentLibrary.pricing.business.badge"),
      price: "250",
      monthlyPrice: "250",
      annualPrice: "3000",
      currency: t("landing.assessmentLibrary.pricing.currency"),
      features: [
        t("landing.assessmentLibrary.pricing.business.features.credits"),
        t("landing.assessmentLibrary.pricing.business.features.users"),
        t("landing.assessmentLibrary.pricing.business.features.ats"),
        t("landing.assessmentLibrary.pricing.business.features.testInventories"),
        t("landing.assessmentLibrary.pricing.business.features.library"),
        t("landing.assessmentLibrary.pricing.business.features.antiCheating"),
        t("landing.assessmentLibrary.pricing.business.features.support"),
      ],
      highlighted: true,
    },
    {
      name: t("landing.assessmentLibrary.pricing.custom.name"),
      badge: t("landing.assessmentLibrary.pricing.custom.badge"),
      price: t("landing.assessmentLibrary.pricing.custom.price"),
      currency: "",
      features: [
        t("landing.assessmentLibrary.pricing.custom.features.users"),
        t("landing.assessmentLibrary.pricing.custom.features.ats"),
        t("landing.assessmentLibrary.pricing.custom.features.testInventories"),
        t("landing.assessmentLibrary.pricing.custom.features.library"),
        t("landing.assessmentLibrary.pricing.custom.features.antiCheating"),
        t("landing.assessmentLibrary.pricing.custom.features.support"),
      ],
      highlighted: false,
    },
  ];

  return (
    <Row className="justify-content-center my-5">
      <Col xs={12} xl={11} xxl={10}>
        <Row className="justify-content-center g-4">
          {plans.map((plan, index) => (
            <Col key={index} xs={12} md={6} lg={3}>
              <Card
                className="h-100 shadow-sm"
                style={{
                  border: plan.highlighted ? "3px solid #007bff" : "1px solid #dee2e6",
                  borderRadius: "15px",
                  transition: "transform 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-10px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                <Card.Body className="d-flex flex-column p-4">
                  <div
                    className="text-center mb-3 py-2 px-3"
                    style={{
                      backgroundColor: plan.highlighted ? "#007bff" : "#f8f9fa",
                      color: plan.highlighted ? "white" : "#333",
                      borderRadius: "20px",
                      fontWeight: "600",
                      fontSize: "14px",
                    }}
                  >
                    {plan.badge}
                  </div>

                  <div className="text-center mb-4">
                    <h3 className="fw-bold mb-3" style={{ fontSize: "20px", color: "#333" }}>
                      {plan.price} {plan.currency}
                    </h3>
                    {plan.monthlyPrice && (
                      <div style={{ fontSize: "12px", color: "#666" }}>
                        {plan.monthlyPrice} {plan.currency}{" "}
                        {t("landing.assessmentLibrary.pricing.monthly")} ({plan.annualPrice}{" "}
                        {plan.currency} {t("landing.assessmentLibrary.pricing.annual")})
                      </div>
                    )}
                  </div>

                  <div className="flex-grow-1">
                    {plan.features.map((feature, featureIndex) => (
                      <div
                        key={featureIndex}
                        className="d-flex align-items-start mb-2"
                        style={{ fontSize: "13px" }}
                      >
                        <span
                          className="me-2"
                          style={{
                            color: "#28a745",
                            fontSize: "16px",
                            minWidth: "20px",
                          }}
                        >
                          ✓
                        </span>
                        <span style={{ color: "#555" }}>{feature}</span>
                      </div>
                    ))}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Col>
    </Row>
  );
};

export default PricingSection;
